import * as _ from "lodash";
import {IEdgeModel} from "@/shared/models/abstract/IEdgeModel";
import {EntityType} from "@/shared/models/entityType";
import EdgeBaseModel from "@/shared/models/abstract/edgeBaseModel";
import DataGenerator from "@/shared/DataGenerator";

/**
 * The default edge used to connect entities.
 */
export class DefaultEdgeModel extends EdgeBaseModel implements IEdgeModel {


    constructor(sourceId: string, targetId: string) {
        super(EntityType.DefaultEdge, sourceId, targetId);
    }


    clone() {
        const clone = DefaultEdgeModel.fromJson(this.toJson());
        clone.id = DataGenerator.id();
        return clone;
    }
};




